import { useEffect, useRef, useState } from "react";

export function useBuildWatcher(intervalMs = 60000) {
  const [hasUpdate, setHasUpdate] = useState(false);
  const current = useRef(null);

  useEffect(() => {
    let timer;

    const check = async () => {
      try {
        const base = import.meta.env.BASE_URL || "/";
        const res = await fetch(`${base}version.json?_=${Date.now()}`, {
          cache: "no-store",
        });
        if (!res.ok) return;
        const data = await res.json();

        // // log válido (data existe aquí)
        // console.log("[watcher] check()", {
        //   current: current.current,
        //   incoming: data.version,
        // });

        if (!current.current) {
          current.current = data.version; // primera lectura
          return;
        }
        if (data.version && data.version !== current.current) {
          setHasUpdate(true);
        }
      } catch (e) {
        // opcional: console.warn("[watcher] error", e);
      }
    };

    check();
    timer = setInterval(check, intervalMs);

    return () => {
      if (timer) clearInterval(timer);
    };
  }, [intervalMs]);

  const applyUpdate = () => {
    // Limpia ?v= si existiera y recarga duro
    const url = new URL(window.location.href);
    url.searchParams.delete("v");
    window.history.replaceState({}, "", url.toString());
    window.location.reload();
  };

  return { hasUpdate, applyUpdate };
}
